import { PlanItem, PlanResponse } from '@/types/service-response'
import { Absence } from '@/model/absences/Absence'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import moment from 'moment'
import store from '@/store'
import { GET_IS_ALL_DAY_LONG } from '@/store/getter-types'
import { ViewEnum } from '@/types/enums'
import { getColorContrast } from '@/services/get-color-contrast'

export class EmployeeEvent {
  private constructor (
    readonly id: number,
    readonly employeeId: number,
    readonly resourceId: number,
    readonly name: string,
    readonly startDate: string,
    readonly endDate: string,
    readonly startDateOriginal: string,
    readonly endDateOriginal: string,
    readonly eventColor: string,
    readonly type: string,
    readonly absenceId: number | null,
    readonly kaId: number | null,
    readonly projectSerieId: number | null,
    readonly projectId: number | null,
    readonly department: number,
    readonly category: number | null,
    readonly projectShiftDetailId: number | null,
    readonly addressId: number | null,
    readonly addressNumber: string,
    readonly referenzProjektId: number | null,
    readonly abonnementId: number | null,
    readonly shiftBreakList: ShiftBreak[],
    readonly isReplacement: boolean,
    readonly responsibleId: number | null,
    readonly status: string,
    readonly colorCode: string,
    readonly serie: number | null,
    readonly resizable?: boolean,
    readonly draggable?: boolean,
    readonly style?: string
  ) {}

  public static createListFromResponse (data: PlanResponse, view: ViewEnum, allowShiftDragAndDrop?: boolean): Array<EmployeeEvent> {
    const isAllDayLong = store.getters[GET_IS_ALL_DAY_LONG]
    const list = data.map((planItem: PlanItem, idx: number) => {
      let shiftBreakList: ShiftBreak[] = ShiftBreak.createFromResponse(planItem.SchichtenPausenData)
      const isResizable = !(planItem.Status === 'inaktiv' || planItem.type === 'originalShift' || planItem.type === 'calendar' || planItem.type === 'floater' || planItem.type === 'absence' || !allowShiftDragAndDrop || (isAllDayLong && view !== ViewEnum.Day))
      const isDraggable = !(planItem.Status === 'inaktiv' || planItem.type === 'originalShift' || planItem.type === 'calendar' || planItem.type === 'floater' || planItem.type === 'absence' || !allowShiftDragAndDrop)

      let startDate = planItem.startDate
      let endDate = planItem.endDate

      if(isAllDayLong && view !== ViewEnum.Day && planItem.type !== 'absence' && planItem.type !== 'calendar') {
        startDate = moment(planItem.endDate).startOf('date').toISOString()
        endDate = moment(planItem.endDate).endOf('date').toISOString()
      }

      let textColor: string = '#ffffff'
      let style: string | undefined = planItem.style
      if(planItem.type === 'absence') {
        textColor = getColorContrast(planItem.color ? planItem.color : '#ffffff')
        style = `background-color: ${planItem.color}; color: ${textColor === 'white' ? textColor + '!important' : textColor };`
      }

      return new EmployeeEvent(
        idx + 1,
        planItem.mitabeiterID,
        planItem.mitabeiterID,
        planItem.text,
        startDate,
        endDate,
        planItem.startDate,
        planItem.endDate,
        planItem.type === 'originalShift'? 'lightgray' : planItem.color,
        planItem.type,
        planItem.AbsenceID,
        planItem.KAID,
        planItem.type === 'originalShift'? null : planItem.projectSerienID,
        planItem.projectID,
        planItem.Abteilung,
        planItem.Kategorie,
        planItem.projektSchichtDetailID,
        planItem.AdressID,
        planItem.AdressNummer ? planItem.AdressNummer : '',
        planItem.ReferenzProjektID ? planItem.ReferenzProjektID : null,
        planItem.AbonnementID ? planItem.AbonnementID : null,
        shiftBreakList,
        planItem.STV === 1,
        planItem.mitarbeiterID_STV,
        planItem.Status,
        planItem.colorCode ? planItem.colorCode : '',
        planItem.type === 'originalShift'? planItem.projectSerienID : null,
        isResizable,
        isDraggable,
        style
      )
    })

    return list
  }

  public static createListFromAbsenceList (data: Array<Absence>, id: number, allowAbsenceDragAndDrop: boolean): Array<EmployeeEvent> {
    const absenceEventList = data.map((item: Absence) => {
      const isResizableAndDraggable = allowAbsenceDragAndDrop
      const textColor: string = getColorContrast(item.color ? item.color : '#ffffff')
      const style = `background-color: ${item.color}; color: ${textColor === 'white' ? textColor + '!important' : textColor };`
      id++
      return new EmployeeEvent(
        id,
        item.employeeId,
        item.employeeId,
        item.basicName,
        item.start.toString(),
        item.end.toString(),
        item.start.toString(),
        item.end.toString(),
        item.color ? item.color : '#F44336',
        'absence',
        item.id,
        null,
        null,
        null,
        item.department,
        null,
        null,
        null,
        '',
        null,
        null,
        [],
        false,
        null,
        '',
        '',
        item.serieId,
        isResizableAndDraggable,
        isResizableAndDraggable,
        style
      )
    })

    return absenceEventList
  }
}
